module.exports = __webpack_public_path__ + "img/Open-window.da85a6cb.svg";